<template>
  <div>
    <div class="navtit">
      {{$t('home.nav1')}}
    </div>
    <div class="banner">
      <img src="../assets/12.jpg" alt="">
    </div>
    <div class="container">
      <div class="descript-top">
        <el-row :gutter="50">
          <el-col :span="12">
            <div class="descript-title">
              {{$t('item1.tit')}}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="descript-content">
              {{$t('item1.txt')}}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="descript-btm">
        <el-row :gutter="60">
          <el-col :span="12">
            <div class="descript-item">
              <div class="descript-item-top">No.1</div>
              <!-- <div class="descript-item-mid"></div> -->
              <div class="descript-item-btm">
                {{$t('item1.txt1')}}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="descript-item">
              <div class="descript-item-top">No.5</div>
              <!-- <div class="descript-item-mid"></div> -->
              <div class="descript-item-btm">
                {{$t('item1.txt2')}}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="Ktit">
        股票信息
      </div>
      <div class="Kimg">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="分时K线" name="first">
            <img src="http://image.sinajs.cn/newchart/hk_stock/min/02520.gif" alt="">
          </el-tab-pane>
          <el-tab-pane label="日K线图" name="second">
            <img src="http://image.sinajs.cn/newchart/hk_stock/daily/02520.gif" alt="">
          </el-tab-pane>
          <el-tab-pane label="周K线图" name="third">
            <img src="http://image.sinajs.cn/newchart/hk_stock/weekly/02520.gif" alt="">
          </el-tab-pane>
          <el-tab-pane label="月K线图" name="fourth">
            <img src="http://image.sinajs.cn/newchart/hk_stock/monthly/02520.gif" alt="">
          </el-tab-pane>
        </el-tabs>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      activeName: 'first'
    }
  },
  mounted () {
    console.log()
  },
  methods: {

  }
}
</script>
<style scoped>
.navtit{
  font-size: 36px;
    color: #000000;
    line-height: 45px;
    text-align: center;
    padding: 30px 60px;
}
.Ktit{
  font-size: 30px;
  color: #000000;
  line-height: 45px;
  text-align: center;
  padding: 30px 0 30px 0;
}
.banner{
  width: 100%;
  height: 540px;
  margin: 0 auto;
  overflow: hidden;
}
.banner img{
  width: 100%;
  height: 100%;
}
.container {
  width: 1050px;
  margin: 0 auto;
  padding: 80px 0;
}
.descript-title {
  width: 100%;
  font-size: 37px;
  color: #000000;
  line-height: 55px;
  letter-spacing: 0.4375rem;
  text-align: left;
}
.descript-content {
  width: 100%;
  font-size: 16px;
  color: #656565;
  line-height: 24px;
  text-align: left;
}
.descript-btm {
  margin-top: 20px;
}
.descript-item {
  background-color: #f7f7f7;
  width: 100%;
  height: 100px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.descript-item-top {
  font-size: 30px;
  color: #409EFF;
  line-height: 40px;
}
.descript-item-mid {
  font-size: 14px;
  color: #ff9faa;
  line-height: 24px;
  height: 24px;
}
.descript-item-btm {
  font-size: 18px;
  color: #494949;
  line-height: 30px;
}
.Kimg{
  width: 100%;
  margin: 0 auto;
}
</style>
